import axios from 'axios'

export const fetchToftaUrl = async (): Promise<string> => {
  const raw = await axios.get(process.env.VUE_APP_VARIABLE_TOFTA_URL)
  return raw.data
}
